/**
 * Feedback hook — daily motivational card based on completion %.
 */

import { useQuery } from '@tanstack/react-query'
import { fetchDailyFeedback } from '@turnifly/shared/api'
import { getLocalTodayStr } from '@turnifly/shared/utils'

export const feedbackKeys = {
  daily: (userId: string, date: string) => ['feedback', 'daily', userId, date] as const,
} as const

export function useDailyFeedback(userId: string | undefined, date?: string) {
  const today = date ?? getLocalTodayStr()

  return useQuery({
    queryKey: feedbackKeys.daily(userId ?? '', today),
    queryFn: () => fetchDailyFeedback(userId!, today),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
